import { Badge } from '@/components/ui/badge'

const statusStyles: Record<string, string> = {
  Approved: 'bg-success text-success-foreground border !border-success-foreground hover:bg-success font-bold tracking-[0.015em] h-6 px-2.5 rounded-full',
  Draft: 'bg-warning text-warning-foreground border !border-warning-foreground hover:bg-warning font-bold tracking-[0.015em] h-6 px-2.5 rounded-full',
  Archived: 'bg-neutral text-neutral-foreground border !border-neutral-foreground hover:bg-neutral font-bold tracking-[0.015em] h-6 px-2.5 rounded-full',
  'In Review': 'bg-purple text-purple-foreground border !border-purple-foreground hover:bg-purple font-bold tracking-[0.015em] h-6 px-2.5 rounded-full',
}

export function StatusBadge({ status, label, testIdPrefix }: { status: string; label: string; testIdPrefix: string }) {
  return (
    <Badge
      variant="secondary"
      data-testid={`${testIdPrefix}-status-${status}`}
      className={`${statusStyles[status] ?? 'bg-muted text-muted-foreground hover:bg-muted'}`}
    >
      {label}
    </Badge>
  )
}
